<template>
  <v-dialog
    v-model="dateDialog"
    full-width
    width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        ref="input"
        v-model="formattedDate"
        append-icon="event"
        @click:append="dateDialog = true"
        readonly
        v-bind="$attrs"
        v-on="on"
        :disabled="disabled"
      >
        <template v-slot:prepend>
          <slot name="prepend"></slot>
        </template>
        <template v-slot:append>
          <slot name="append"></slot>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      v-model="dateValue"
      @input="dateDialog = false"
      :max="max"
      :min="min"
      :disabled="disabled"
      no-title
      @change="$emit('change', $event)"
    ></v-date-picker>
  </v-dialog>
</template>

<script>
import { DateFormat } from '../plugins/date-filter';
import moment from 'moment';

export default {
  name: 'DateInput',
  props: {
    value: {
      required: true,
    },
    max: null,
    min: null,
    disabled: false,
  },
  data() {
    return {
      dateDialog: false,
      dateValue: '',
    };
  },
  computed: {
    formattedDate() {
      return this.value ? moment(this.value).format(DateFormat.DefaultDisplay) : '';
    },
  },
  created() {
    this.dateValue = this.value;
  },
  watch: {
    dateValue(val) {
      this.$emit('input', val);
    },
  },
};
</script>
